import React, { useMemo, useCallback } from 'react';
import { withLocalize } from 'react-localize-redux';
import _ from 'lodash';
import { Text } from '../Text';
import { useLocalize } from '../../../hooks';
const FieldRequirementContent = ({ type, min, max, valid, data, translate, color }) => {
    const { getTranslationId } = useLocalize();
    const formatNumberAsTranslatedDigit = useCallback((value) => {
        if (value && value < 10) {
            const translatedDigit = translate(getTranslationId({ id: `digits.${value}`, type: 'page' }));
            if (_.isString(translatedDigit)) {
                return translatedDigit;
            }
        }
        return `${value}`;
    }, [translate, getTranslationId]);
    const fieldLabel = useMemo(() => {
        switch (type) {
            case 'length-min':
            case 'length-range':
            case 'special-min':
            case 'special-acceptable':
                return 'characters';
            case 'lower-min':
            case 'upper-min':
                return 'letters';
            case 'digit-min':
                return 'digits';
            case 'contains-username':
            case 'equals-email':
            case 'contains-first-name':
            case 'contains-forbidden-keywords':
            case 'contains-last-name':
            case 'repeated-password':
                return type;
        }
    }, [type]);
    const typeLabel = useMemo(() => {
        const fieldTypeId = `${fieldLabel}-label.${!min || min !== 1 ? 'plural' : 'singular'}`;
        const translatedLabel = translate(getTranslationId({ id: fieldTypeId, type: 'page' }));
        return _.isString(translatedLabel) ? translatedLabel : fieldLabel;
    }, [fieldLabel, min, translate, getTranslationId]);
    const textData = useMemo(() => (Object.assign({}, data, { min: max ? min : formatNumberAsTranslatedDigit(min), max, label: typeLabel })), [data, min, max, typeLabel, formatNumberAsTranslatedDigit]);
    if (!min) {
        return null;
    }
    return (React.createElement("li", { style: { color: color ? color : 'initial' } },
        !_.isUndefined(valid) && (React.createElement(React.Fragment, null,
            React.createElement("i", { className: `fa ${valid ? `fa-check ${color}` : 'fa-exclamation-circle error'}` }),
            ' ')),
        React.createElement(Text, { id: `fieldRequirements.${type}`, page: "secure", data: textData })));
};
export const FieldRequirement = withLocalize(FieldRequirementContent);
//# sourceMappingURL=FieldRequirement.js.map